import { LogStringToLoggerLevel } from 'src/types';

export const DEFAULT_POOL_SIZE = 2;

export enum LOGGER_LEVEL {
    DEBUG = 0,
    INFO = 1,
    WARNING = 2,
    ERROR = 3,
    CRITICAL = 4,
}

export const LEVEL_NAME: LogStringToLoggerLevel = {
    critical: LOGGER_LEVEL.CRITICAL,
    debug: LOGGER_LEVEL.DEBUG,
    error: LOGGER_LEVEL.ERROR,
    info: LOGGER_LEVEL.INFO,
    warning: LOGGER_LEVEL.WARNING,
};
